import { type FC } from 'react';

import { GenericButton } from '@shared/components/ui/custom';

interface ModalOverlayProps {
  isError: boolean;
  isFetching?: boolean;
  errorMessage?: string;
  refetch?: () => void;
  noDataMessage?: string;
}

export const ModalOverlay: FC<ModalOverlayProps> = (props) => {
  const {
    isError,
    isFetching = false,
    errorMessage = 'Error fetching data',
    noDataMessage = 'No data to display',
    refetch,
  } = props;

  const message = isError ? errorMessage : noDataMessage;
  const showRetryButton = !isFetching && isError && typeof refetch === 'function';

  return (
    <div
      className="flex flex-col items-center justify-center w-full min-h-[120px] rounded-lg border border-dashed border-border bg-muted/40 p-6"
      data-testid="modal-state-container"
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <h3 className="text-sm font-medium text-muted-foreground" data-testid="modal-state-title">
          {message}
        </h3>
        {showRetryButton && (
          <GenericButton
            onClick={refetch}
            variant="link"
            className="text-sm h-auto p-0 font-normal text-primary underline-offset-4 hover:underline cursor-pointer"
            data-testid="modal-state-retry-button"
          >
            Retry
          </GenericButton>
        )}
      </div>
    </div>
  );
};
